import { Component } from '@angular/core';

@Component({
  selector: 'app-noresult',
  templateUrl: './noresult.component.html',
  styleUrl: './noresult.component.scss'
})
export class NoresultComponent {

}
